import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditSkillsForm } from '../../../components/cv/forms/EditSkillsForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useSaveSkillGroups } from '../../../hooks/useProfileApi';

export default function EditSkillsWebScreen() {
  const { t } = useTranslation('seeker');
  const { profileRef } = useCVData();
  const saveSkills = useSaveSkillGroups();

  const handleSave = async () => {
    await saveSkills.mutateAsync(profileRef.current.skillGroups);
  };

  return (
    <WebEditPageShell title={t('cv.edit.skills')}>
      <EditSkillsForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
